import './App.css';
import Dashboard from './Dashboard';

function App() {
  return (
    <Dashboard />
  );
}

// Metrics -> Financial Metrics
// Return on investment -> ROI
// Account -> Team
// Spacing
// Loading screen
// Same order in Perfo Comparison and Chart

export default App;
